var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.init
    ? _c(
        "div",
        { staticClass: "component-part" },
        [
          _vm.writingData.is_submitted
            ? _c("Finish", { attrs: { data: _vm.writingData } })
            : _c("div", { staticClass: "component-form" }, [
                _c(
                  "div",
                  { staticClass: "page-content" },
                  [
                    _c("h1", { staticClass: "h1 color-black" }, [
                      _vm._v("Schedule An Appointment")
                    ]),
                    _c("p", { staticClass: "text1 bold color-red-default" }, [
                      _vm._v(
                        "Part 2 Drafting, Editing & Revision - 15 mins/person (English), 20 mins/person (Chinese)"
                      )
                    ]),
                    _c("p", { staticClass: "text1 color-gray-2 mt-30" }, [
                      _vm._v(
                        " Once you start writing your first draft, you can sign up for Appointment 2. The instructional language of Appointment 2 will be either English or Chinese. "
                      )
                    ]),
                    _vm.timeOptions.length
                      ? _c(
                          "div",
                          { staticClass: "times-select-wrap" },
                          _vm._l(_vm.timeOptions, function(item) {
                            return _c(
                              "CheckboxSlot",
                              {
                                key: item.option_time,
                                staticClass: "radio-item",
                                attrs: {
                                  value:
                                    _vm.form.option_time === item.option_time
                                },
                                on: {
                                  input: function($event) {
                                    _vm.form.option_time = item.option_time
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "time-wrap" }, [
                                  _c(
                                    "span",
                                    { staticClass: "text1 color-gray-2" },
                                    [_vm._v(_vm._s(item.option_time))]
                                  ),
                                  _c("div", {
                                    staticClass: "lang",
                                    class: {
                                      cn: item.lang === "Chinese",
                                      en: item.lang !== "Chinese"
                                    }
                                  })
                                ])
                              ]
                            )
                          }),
                          1
                        )
                      : _c(
                          "p",
                          { staticClass: "h2 color-red-default bold mt-10" },
                          [_vm._v("This part is fully booked，no vacant seat")]
                        ),
                    _c("p", { staticClass: "text1 bold color-gray-1 mt-20" }, [
                      _vm._v("Sign-up Page")
                    ]),
                    _c("p", { staticClass: "text1 bold color-gray-1 mt-" }, [
                      _vm._v("Your paper title")
                    ]),
                    _c("TextareaPrototype", {
                      staticClass: "textarea-wrap mt-10",
                      attrs: { counter: false, placeholder: "" },
                      model: {
                        value: _vm.form.title,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title"
                      }
                    }),
                    _c("p", { staticClass: "text1 bold mt-20 color-gray-1" }, [
                      _vm._v("Tell the tutor about your writing progress")
                    ]),
                    _c(
                      "div",
                      { staticClass: "progress-wrap mt-20" },
                      _vm._l(_vm.progressOptions, function(item) {
                        return _c(
                          "RadioSlot",
                          {
                            key: item,
                            staticClass: "radio-item",
                            attrs: { value: _vm.form.progress === item },
                            on: {
                              input: function($event) {
                                _vm.form.progress = item
                              }
                            }
                          },
                          [
                            _c("p", { staticClass: "text1 color-gray-2" }, [
                              _vm._v(_vm._s(item))
                            ])
                          ]
                        )
                      }),
                      1
                    ),
                    _c("p", { staticClass: "text1 color-gray-1 bold mt-30" }, [
                      _vm._v(
                        "Briefly note questions/concerns in a list here (no more than 3)"
                      )
                    ]),
                    _c("TextareaPrototype", {
                      staticClass: "textarea-wrap mt-10",
                      attrs: { counter: false, placeholder: "" },
                      model: {
                        value: _vm.form.questions,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "questions", $$v)
                        },
                        expression: "form.questions"
                      }
                    }),
                    _c("p", { staticClass: "text1 bold color-gray-1 mt-20" }, [
                      _vm._v(
                        "Upload a complete outline as much of the paper as possible (Optional)"
                      )
                    ]),
                    _c("FileUploader", {
                      staticClass: "uploader-wrap mt-10",
                      attrs: {
                        text: "Upload your outline",
                        loadText: "loading..."
                      },
                      model: {
                        value: _vm.form.outline,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "outline", $$v)
                        },
                        expression: "form.outline"
                      }
                    }),
                    _c(
                      "Button",
                      {
                        staticClass: "btn-submit",
                        on: { click: _vm.handleClickSubmit }
                      },
                      [_vm._v("Submit")]
                    )
                  ],
                  1
                )
              ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }